module.exports = __webpack_public_path__ + "img/login.9b8ff58b.png";